import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  IconButton,
  Stack,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Modal,
  TextField,
  CircularProgress,
} from "@mui/material";
import activeoffers from "../../images/activeoffers.png";
import dashboarddelete from "../../images/dashboarddelete.png";
import dashboardedit from "../../images/dashboardedit.png";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../axios";
import { BusinessContext } from "../BusinessContext";
import { styled } from "@mui/system";
import imageCompression from "browser-image-compression";
import AWS from "aws-sdk";
import imageoffer from "../../images/imageoffer.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useTranslation } from "react-i18next";

function Offers() {
  const [value, setValue] = useState(0);
  const [addOffer, setAddOffer] = useState(false);
  const [editOffer, setEditOffer] = useState(false);
  const [specialToEdit, setSpecialToEdit] = useState(null);
  const { selectedBusinessId } = useContext(BusinessContext);
  const [businessData, setBusinessData] = useState([]);
  const [businessDataspecials, setBusinessDataspecials] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [cardsPerSlide, setCardsPerSlide] = useState();

  const sliderRef = useRef(null);
  const [specialFormdata, setSpecialFormData] = useState({
    menu_name: "",
    menu_description: "",
    // price: "",
    expiration_date: "",
    status: "1",
    menu_image: null,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [specialToDelete, setSpecialToDelete] = useState(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [copiedCardId, setCopiedCardId] = useState(null);
  const { t } = useTranslation();



  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize to midnight
  
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    endpoint: process.env.REACT_APP_AWS_BASE_URL,
    s3ForcePathStyle: true,
    signatureVersion: "v4",
  });
  const s3 = new AWS.S3();

  const handleOpenAddOffer = () => {
    setAddOffer(true);
  };

  const handleCloseAddOffer = () => {
    setAddOffer(false);
    setFormErrors({});
    setSpecialFormData({
      menu_name: "",
      menu_description: "",
      // price: "",
      expiration_date: "",
      status: "1",
      menu_image: null,
    });
    setUploadedImageUrl(null);
  };

  const handleOpenEditOffer = (special) => {
    setSpecialToEdit({
      ...special,
      menu_image: special.image,
      // status: special.status === 1 ? "1" : "0"
      status: special.status === "1" ? "Active" : "Inactive",
    });
    setEditOffer(true);
  };

  const handleCloseEditOffer = () => {
    setEditOffer(false);
    setSpecialToEdit(null);
    setFormErrors({});
  };

  const Customslider = styled(Box)({
    // slider: {
    //   "& .slick-slide": {
    //     marginRight: "16px",
    //   },
    // },
    display: "flex",
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setCardsPerSlide(1);
      } else if (window.innerWidth < 1440) {
        setCardsPerSlide(2);
      } else {
        setCardsPerSlide(3);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchBusinessesspecials = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post(
          "places.php?method=get_business_specials",
          {
            business_id: selectedBusinessId,
          }
        );
        if (response.data.place_details);
        setBusinessDataspecials(response.data);
      } catch (err) {
        console.log("error", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBusinessesspecials();
  }, [selectedBusinessId]);

  useEffect(() => {
    const fetchBusinesses = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post(
          "places.php?method=get_place_details",
          {
            id: selectedBusinessId,
          }
        );
        if (response.data.place_details);
        setBusinessData(response.data.place_details);
      } catch (err) {
        console.log("error", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBusinesses();
  }, [selectedBusinessId]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const validateForm = (isEdit = false) => {
    const errors = {};
    if (!specialFormdata.menu_name) errors.menu_name = "Menu name is required";
    // if (!specialFormdata.price) errors.price = "Price is required";
    if (!specialFormdata.coupon_code)
      errors.coupon_code = "Coupon code is required";
    if (!specialFormdata.expiration_date)
      errors.expiration_date = "Expiration date is required";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsImageUploading(true);
    try {
      // Compress image
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 800,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file, options);

      // Upload to S3
      const params = {
        Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
        Key: `${Date.now()}-${file.name}`,
        Body: compressedFile,
        ContentType: file.type,
        ACL: "public-read",
      };

      const uploadResult = await s3.upload(params).promise();
      setUploadedImageUrl(uploadResult.Location);
      setSpecialFormData((prev) => ({
        ...prev,
        menu_image: uploadResult.Location,
      }));
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsImageUploading(false);
    }
  };

  const handleImageDelete = () => {
    setUploadedImageUrl(null);
    setSpecialFormData((prev) => ({
      ...prev,
      menu_image: null,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSpecialFormData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (name === "coupon_code" && value) {
      if (value.length < 4) {
        setFormErrors((prev) => ({
          ...prev,
          coupon_code: "Coupon code must be at least 4 characters long.",
        }));
      } else if (value.length > 12) {
        setFormErrors((prev) => ({
          ...prev,
          coupon_code: "Coupon code must not exceed 12 characters.",
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, coupon_code: "" }));
      }
    }
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const payload = {
        ...specialFormdata,
        business_id: selectedBusinessId,
        price:"0",
        expiration_date: specialFormdata.expiration_date,
        status: specialFormdata.status === "1" ? "1" : "0",
        ...(uploadedImageUrl && { menu_image: uploadedImageUrl }),
      };

      const response = await axiosInstance.post(
        "places.php?method=add_special",
        payload
      );

      if (response.data.status === "success") {
        // First close the modal
        handleCloseAddOffer();

        // Reset form data
        setSpecialFormData({
          menu_name: "",
          menu_description: "",
          // price: "",
          expiration_date: "",
          status: "1",
          menu_image: null,
        });
        setUploadedImageUrl(null);

        // Refresh the business data to get updated specials
        const updatedResponse = await axiosInstance.post(
          "places.php?method=get_business_specials",
          {
            business_id: selectedBusinessId,
          }
        );

        if (updatedResponse.data) {
          setBusinessDataspecials(updatedResponse.data);
        }
      }
    } catch (error) {
      console.error("Error adding offer:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteSpecial = async (specialId) => {
    try {
      const response = await axiosInstance.post(
        "places.php?method=delete_menu_item",
        {
          id: specialId,
        }
      );

      if (response.data.status === "success") {
        // First close the modal
        setDeleteDialogOpen(false);
        setSpecialToDelete(null);

        // Refresh the business data to get updated specials
        const updatedResponse = await axiosInstance.post(
          "places.php?method=get_business_specials",
          {
            business_id: selectedBusinessId,
          }
        );

        if (updatedResponse.data) {
          setBusinessDataspecials(updatedResponse.data);
        }
      }
    } catch (error) {
      console.error("Error deleting special:", error);
    }
  };

  const isFormValid =
    specialFormdata.menu_name?.trim() &&
    // specialFormdata.price &&
    specialFormdata.coupon_code?.trim() &&
    specialFormdata.expiration_date &&
    !Object.values(formErrors).some(Boolean);

  const handleEditSubmit = async () => {
    // Clear any existing errors first
    setFormErrors({});

    // Validate required fields
    const errors = {};
    if (!specialToEdit?.menu_name?.trim()) {
      errors.menu_name = "Menu name is required";
    }
    // if (!specialToEdit?.price) {
    //   errors.price = "Price is required";
    // }
    if (!specialToEdit?.coupon_code?.trim()) {
      errors.coupon_code = "Coupon code is required";
    }
    if (!specialToEdit?.expiration_date) {
      errors.expiration_date = "Expiration date is required";
    }

    // If there are any errors, set them and return
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setIsSubmitting(true);
    try {
      const { image, ...payload } = {
        ...specialToEdit,
        price:"0",
        business_id: selectedBusinessId,
        expiration_date: specialToEdit.expiration_date,
        status: specialToEdit.status === "Active" ? "1" : "0",
      };

      const response = await axiosInstance.post(
        "places.php?method=edit_special",
        payload
      );

      if (response.data.status === "success") {
        handleCloseEditOffer();
        setSpecialToEdit(null);

        // Refresh the business data to get updated specials
        const updatedResponse = await axiosInstance.post(
          "places.php?method=get_business_specials",
          {
            business_id: selectedBusinessId,
          }
        );

        if (updatedResponse.data) {
          setBusinessDataspecials(updatedResponse.data);
        }
      }
    } catch (error) {
      console.error("Error updating offer:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isloading) {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh", // Full viewport height
          }}
        >
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (!selectedBusinessId) {
    return (
      <>
        <Typography
          sx={{
            textAlign: "center",
            pt: "50px",
            fontFamily: "Nunito",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          No businesses available at the moment.
        </Typography>
      </>
    );
  }

  const handleCopy = (text, id) => {
    if (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedCardId(id); // set card ID for message
          setTimeout(() => setCopiedCardId(null), 1000); // clear message after 2s
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };
  

  return (
    <Box sx={{ p: { xs: "10px 9px 10px 8px", sm: "10px  0px 10px 10px" }, color: "var(--pg-text)" }}>
      <Box
        sx={{
          borderRadius: "8px",
          px: "18px",
          pb: "15px",
          pt: "10px",
          backgroundColor: "var(--pg-card)",
          color: "var(--pg-text)",
          border: "1px solid var(--pg-border)",
          mt: "10px",
        }}
      >
        <Box
          sx={{
            display: { xs: "flex", sm: "flex" },
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid var(--pg-border)",
            pb: "8px",
            heminHeight: "32px",
          }}
        >
          <Box sx={{ order: { xs: "2", sm: "1",overflowX: "auto", whiteSpace: "nowrap" , } }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              variant="scrollable"
              scrollButtons={false}
              aria-label="scrollable prevent tabs example"
              sx={
                {
              mt:{xs:"10px",sm:"0px"}
                }
              }
            >
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <Box component="img" src={activeoffers} pr={"3px"} />
                    {t("Active Offers")}
                  </Box>
                }
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textTransform: "capitalize",
                  color: value === 0 ? "#0041A8" : "var(--pg-text)",
                  borderBottom: value === 0 ? "3px solid #0041A8" : "none",
                  p: 0,
                  minWidth: "auto",
                  marginRight: "25px",
                }}
              />

              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <DoNotDisturbIcon sx={{fontSize:"18px" ,mr:"3px"}}/>
                    {t("Inactive Offers")}
                  </Box>
                }
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textTransform: "capitalize",
                  color: value === 1 ? "#0041A8" : "var(--pg-text)",
                  borderBottom: value === 1 ? "3px solid #0041A8" : "none",
                  p: 0,
                  minWidth: "auto",
                  marginRight: "25px",
                }}
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                   <EventBusyIcon sx={{fontSize:"18px", mr:"4px"}}/>
                   {t("Expired Offers")}
                  </Box>
                }
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textTransform: "capitalize",
                  color: value === 2 ? "#0041A8" : "var(--pg-text)",
                  borderBottom: value === 2 ? "3px solid #0041A8" : "none",
                  p: 0,
                  minWidth: "auto",
                  marginRight: "25px",
                }}
              />
            </Tabs>
          </Box>
          <Box sx={{ order: { xs: "1", sm: "2" } }}>
            <Button
              sx={{
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: "500",
                lineHeight: "21px",
                color: "#0041A8",
                textTransform: "capitalize",
                border: "1px solid #0041A8",
                borderRadius: "27px",
                px: "12px",
                py: "4px",
              }}
              onClick={handleOpenAddOffer}
            >
              +{t("Create New Offer")}
            </Button>
          </Box>
        </Box>
        {value === 0 && (
          <Box width="100%" textAlign="center" pt={"10px"} pb={"8px"}>
            {businessDataspecials?.specials?.filter(
              (item) => item.status === "1"
            )?.length > 0 ? (
              <>
              <Grid
                container
                gap={{ xs: "8px", xl: "12px" }}
                sx={{ justifyContent: { xs: "center", sm: "start" } }}
              >
                {businessDataspecials?.specials
                  ?.filter((item) => item.status === "1")
                  .map((item) => (
                    <Grid
                      item
                      xs={12}
                      sm={5.4}
                      md={3.6}
                      lg={2.8}
                      xl={2.3}
                      key={item.id}
                      sx={{
                        // maxWidth: "224px",
                        height: "250px",
                        borderRadius: "8px",
                        border: "1px solid var(--pg-border)",
                        backgroundColor: "var(--pg-card)",
                        color: "var(--pg-text)",
                        transition: "transform 0.3s ease-in-out",
                        mb: "16px",
                      }}
                    >
                      <Box
                        component="img"
                        src={item.image || imageoffer}
                        alt="Coupon"
                        sx={{
                          width: { xs: "-webkit-fill-available" },
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "5px 5px 0px 0px",
                        }}
                      />

                      <Box sx={{ p: "10px" }}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontSize: "13px",
                            fontFamily: "Roboto",
                            fontWeight: "700",
                            lineHeight: "100%",
                            color: "var(--pg-text)",
                            textAlign: "start",
                            pt: "10px",
                          }}
                        >
                          {item.menu_name}
                        </Typography>
                        <Box>
                          <Stack
                            direction="row"
                            mt={2}
                            alignItems="center"
                            justifyContent={"space-between"}
                          >
                            <Box>
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "#0343AA",
                                  fontSize: "13px",
                                  fontFamily: "Roboto",
                                  fontWeight: "600",
                                  lineHeight: "100%",
                                  textTransform: "capitalize",
                                  borderRadius: "25px",
                                  px: "10px",
                                }}
                              >
                                {item.coupon_code}
                              </Button>
                              <ContentCopyIcon
                                sx={{ fontSize: "15px", ml: "6px",cursor:"pointer" }}
                                onClick={() => handleCopy(item?.coupon_code , item?.id)}
                              />
                            </Box>
                            <Box sx={{ display: "flex", gap: "6px" }}>
                              <Box
                                sx={{
                                  border: "1px solid #DEDEDE",
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "25px",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() => handleOpenEditOffer(item)}
                              >
                                <Box component="img" src={dashboardedit} />
                              </Box>
                              <Box
                                sx={{
                                  border: "1px solid #DEDEDE",
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "25px",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  setSpecialToDelete(item.id);
                                  setDeleteDialogOpen(true);
                                }}
                              >
                                <Box
                                  component="img"
                                  src={dashboarddelete}
                                  sx={{}}
                                />
                              </Box>
                            </Box>
                          </Stack>
                          {copiedCardId === item?.id && (
                       <Box sx={{
                        backgroundColor:"green",
                        borderRadius:"5px",display:"flex",alignItems:"center",justifyContent:"center",gap:"6px",mt:"12px"
                        }}>
                           <CheckCircleIcon sx={{ fontSize: 16, color: "white",mb:"0px" }} />
                       <Typography
                        sx={{
                          fontSize: "12px",
                          color: "white",
                         px:"0px",
                          py:"5px",
                          textAlign: "center",
                          fontFamily:"Roboto",
                          fontWeight:"500"
                        }}
                      >
                      {t("Code copied successfully!")}
                      </Typography>
                      </Box>
                    )}
                        </Box>
                      </Box>


                    </Grid>
                  
                  ))}
                   
              </Grid>

</>

            ) : (
              <>
                <Typography sx={{fontSize:"14px",pt:"10px"}}> {t("No Offers Available")}</Typography>
              </>
            )}

            {/* Navigation Buttons Below */}
          </Box>
        )}
        {value === 1 && (
          <Box width="100%" textAlign="center" pt={"10px"} pb={"8px"}>
            {businessDataspecials?.specials?.filter(
              (item) => item.status === "0"
            )?.length > 0 ? (
              <Grid
                container
                gap={{ xs: "8px", xl: "12px" }}
                sx={{ justifyContent: { xs: "center", sm: "start" } }}
              >
                {businessDataspecials?.specials
                  ?.filter((item) => item.status === "0")
                  .map((item) => (
                    <Grid
                      item
                      xs={12}
                      sm={5.4}
                      md={3.6}
                      lg={2.8}
                      xl={2.3}
                      key={item.id}
                      sx={{
                        height: "250px",
                        borderRadius: "8px",
                        border: "1px solid #DFDFDF",
                        transition: "transform 0.3s ease-in-out",
                        mb: "16px",
                      }}
                    >
                      <Box
                        component="img"
                        src={item.image || imageoffer}
                        alt="Coupon"
                        sx={{
                          width: { xs: "-webkit-fill-available" },
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "5px 5px 0px 0px",
                        }}
                      />

                      <Box sx={{ p: "10px" }}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontSize: "13px",
                            fontFamily: "Roboto",
                            fontWeight: "700",
                            lineHeight: "100%",
                            color: "var(--pg-text)",
                            textAlign: "start",
                            pt: "10px",
                          }}
                        >
                          {item.menu_name}
                        </Typography>
                        <Box>
                          <Stack
                            direction="row"
                            mt={2}
                            alignItems="center"
                            justifyContent={"space-between"}
                          >
                            <Box>
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "#0343AA",
                                  fontSize: "13px",
                                  fontFamily: "Roboto",
                                  fontWeight: "600",
                                  lineHeight: "100%",
                                  textTransform: "capitalize",
                                  borderRadius: "25px",
                                  px: "10px",
                                }}
                              >
                                {item.coupon_code}
                              </Button>
                              <ContentCopyIcon
                                sx={{ fontSize: "15px", ml: "6px",cursor:"pointer" }}
                                onClick={() => handleCopy(item?.coupon_code,item?.id)}
                              />
                            </Box>
                            <Box sx={{ display: "flex", gap: "6px" }}>
                              <Box
                                sx={{
                                  border: "1px solid #DEDEDE",
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "25px",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() => handleOpenEditOffer(item)}
                              >
                                <Box component="img" src={dashboardedit} />
                              </Box>
                              <Box
                                sx={{
                                  border: "1px solid #DEDEDE",
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "25px",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  setSpecialToDelete(item.id);
                                  setDeleteDialogOpen(true);
                                }}
                              >
                                <Box component="img" src={dashboarddelete} />
                              </Box>
                            </Box>
                          </Stack>
                        </Box>
                        {copiedCardId === item?.id && (
                       <Box sx={{
                        backgroundColor:"green",
                        borderRadius:"5px",display:"flex",alignItems:"center",justifyContent:"center",gap:"6px",mt:"12px"
                        }}>
                           <CheckCircleIcon sx={{ fontSize: 16, color: "white",mb:"0px" }} />
                       <Typography
                        sx={{
                          fontSize: "12px",
                          color: "white",
                         px:"0px",
                          py:"5px",
                          textAlign: "center",
                          fontFamily:"Roboto",
                          fontWeight:"500"
                        }}
                      >
                        {t("Code copied successfully!")}
                      </Typography>
                      </Box>
                    )}
                      </Box>
                    </Grid>
                  ))}
              </Grid>
            ) : (
              <Typography sx={{fontSize:"14px",pt:"10px"}}>No Inactive Offers Available</Typography>
            )}
          </Box>
        )}
      {value === 2 && (
  <Box width="100%" textAlign="center" pt="10px" pb="8px">
    {businessDataspecials?.specials?.filter((item) => {
      const expirationDate = new Date(item.expiration_date);
      expirationDate.setHours(0, 0, 0, 0); // clear time for accurate comparison
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return expirationDate < today; // strictly before today
    }).length > 0 ? (
      <Grid
        container
        gap={{ xs: "8px", xl: "12px" }}
        sx={{ justifyContent: { xs: "center", sm: "start" } }}
      >
        {businessDataspecials?.specials
          ?.filter((item) => {
            const expirationDate = new Date(item.expiration_date);
            expirationDate.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return expirationDate < today;
          })
          ?.map((item) => (
            <Grid
              item
              xs={12}
              sm={5.4}
              md={3.6}
              lg={2.8}
              xl={2.3}
              key={item.id}
              sx={{
                height: "250px",
                borderRadius: "8px",
                border: "1px solid #DFDFDF",
                transition: "transform 0.3s ease-in-out",
                mb: "16px",
              }}
            >
              <Box
                component="img"
                src={item.image || imageoffer}
                alt="Coupon"
                sx={{
                  width: { xs: "-webkit-fill-available" },
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "5px 5px 0px 0px",
                }}
              />

              <Box sx={{ p: "10px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "13px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                    textAlign: "start",
                    pt: "10px",
                  }}
                >
                  {item.menu_name}
                </Typography>
                <Box>
                  <Stack
                    direction="row"
                    mt={2}
                    alignItems="center"
                    justifyContent={"space-between"}
                  >
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#0343AA",
                          fontSize: "13px",
                          fontFamily: "Roboto",
                          fontWeight: "600",
                          lineHeight: "100%",
                          textTransform: "capitalize",
                          borderRadius: "25px",
                          px: "10px",
                        }}
                      >
                        {item.coupon_code}
                      </Button>
                      <ContentCopyIcon
                        sx={{ fontSize: "15px", ml: "6px",cursor:"pointer" }}
                        onClick={() => handleCopy(item?.coupon_code,item?.id)}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: "6px" }}>
                      <Box
                        sx={{
                          border: "1px solid #DEDEDE",
                          width: "30px",
                          height: "30px",
                          borderRadius: "25px",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => handleOpenEditOffer(item)}
                      >
                        <Box component="img" src={dashboardedit} />
                      </Box>
                      <Box
                        sx={{
                          border: "1px solid #DEDEDE",
                          width: "30px",
                          height: "30px",
                          borderRadius: "25px",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          setSpecialToDelete(item.id);
                          setDeleteDialogOpen(true);
                        }}
                      >
                        <Box component="img" src={dashboarddelete} />
                      </Box>
                    </Box>
                  </Stack>
                </Box>
                {copiedCardId === item?.id && (
                       <Box sx={{
                        backgroundColor:"green",
                        borderRadius:"5px",display:"flex",alignItems:"center",justifyContent:"center",gap:"6px",mt:"12px"
                        }}>
                           <CheckCircleIcon sx={{ fontSize: 16, color: "white",mb:"0px" }} />
                       <Typography
                        sx={{
                          fontSize: "12px",
                          color: "white",
                         px:"0px",
                          py:"5px",
                          textAlign: "center",
                          fontFamily:"Roboto",
                          fontWeight:"500"
                        }}
                      >
                         {t("Code copied successfully!")}
                      </Typography>
                      </Box>
                    )}
              </Box>
            </Grid>
          ))}
      </Grid>
    ) : (
      <Typography sx={{fontSize:"14px",pt:"10px"}}>{t("No Expired Offers Available")}</Typography>
    )}
  </Box>
)}

      </Box>

      {/* create offer */}
      <Modal
        open={addOffer}
        onClose={handleCloseAddOffer}
        sx={{ overflowY: { xs: "auto" }, bottom: { xs: "10px", sm: "5px" } }}
      >
        <Box
          sx={{
            width: { xs: "85%", sm: "25%" },
            backgroundColor: "var(--pg-card)",
            color: "var(--pg-text)",
            borderRadius: "8px",
            position: "absolute",
            top: { xs: "55%", sm: "" },
            left: "50%",

            transform: "translate(-50%, -50%)",
            boxShadow: 24,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: "#0041A8",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: { xs: "5px 5px", sm: "10px" },
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "18px",
                fontFamily: "Roboto",
                fontWeight: "600",
                lineHeight: "100%",
                pl: "12px",
              }}
            >
                {t("Add Offer")}
            </Typography>
            <IconButton onClick={handleCloseAddOffer} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: { xs: "15px", sm: "16px 25px 28px 25px" } }}>
            {/* Image Upload */}
            <Box
              sx={{
                border: "2px dashed #D3D3D3",
                borderRadius: "8px",
                padding: { xs: "8px", sm: "16px" },
                textAlign: "center",
                margin: { xs: "10px", sm: "16px 0" },
                height: { xs: "70px", sm: "120px" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                position: "relative",
              }}
            >
              <input
                accept="image/*"
                id="image-upload"
                type="file"
                onChange={handleImageUpload}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              {isImageUploading ? (
                <CircularProgress size={24} />
              ) : !uploadedImageUrl ? (
                <Button
                  variant="outlined"
                  component="span"
                  sx={{
                    textAlign: "center",
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    fontWeight: "500",
                    lineHeight: "21px",
                    color: "#0041A8",
                    textTransform: "capitalize",
                    border: "1px solid #0041A8",
                    borderRadius: "25px",
                    textAlign: "center",
                    pointerEvents: "none",
                  }}
                >
                  +{t("Upload Image")}
                </Button>
              ) : (
                <Box
                  sx={{ position: "relative", width: "100%", height: "100%" }}
                >
                  <img
                    src={uploadedImageUrl}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "4px",
                    }}
                  />
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleImageDelete();
                    }}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      backgroundColor: "#acacac",
                      "&:hover": {
                        backgroundColor: "#acacac",
                      },
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      width: "24px",
                      height: "24px",
                      padding: "4px",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: "16px", color: "red" }} />
                  </IconButton>
                </Box>
              )}
              {formErrors.menu_image && (
                <Typography color="error" sx={{ mt: 1 }}>
                  {formErrors.menu_image}
                </Typography>
              )}
            </Box>

            {/* Form Fields */}
            <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
               {t("Offer Title")}
              </Typography>
              <TextField
                fullWidth
                name="menu_name"
                value={specialFormdata.menu_name}
                onChange={handleInputChange}
                error={!!formErrors.menu_name}
                helperText={formErrors.menu_name}
                placeholder="Enter title"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  mt: "10px",
                  mb: "5px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px", // Adjust top-bottom and left-right padding
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  maxLength: 100,
                  style: {
                    padding: "5px 7px", // Decrease padding inside the input
                  },
                }}
              />
              <Typography
                sx={{
                  fontSize: "11px",
                  fontFamily: "Roboto",
                  fontWeight: "400",
                  mb: "5px",
                }}
              >
                Enter up to 100 characters
              </Typography>
            </Box>
            <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                {t("Description")}
              </Typography>
              <TextField
                fullWidth
                name="menu_description"
                value={specialFormdata.menu_description}
                onChange={handleInputChange}
                error={!!formErrors.menu_description}
                helperText={formErrors.menu_desciption}
                multiline
                rows={3}
                placeholder="Enter Description"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  mt: "10px",
                  mb: "5px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px", // Adjust top-bottom and left-right padding
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  maxLength: 500,
                  style: {
                    padding: "5px 7px", // Decrease padding inside the input
                  },
                }}
              />
              <Typography
                sx={{
                  fontSize: "11px",
                  fontFamily: "Roboto",
                  fontWeight: "400",
                  mb: "5px",
                }}
              >
                Enter up to 500 characters
              </Typography>
            </Box>
            {/* <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                Price
              </Typography> */}
              {/* <TextField
                fullWidth
                name="price"
                type="number"
                value={specialFormdata.price}
                onChange={handleInputChange}
                error={!!formErrors.price}
                helperText={formErrors.price}
                placeholder="Enter price"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  my: "10px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px", // Adjust top-bottom and left-right padding
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  style: {
                    padding: "5px 7px", // Decrease padding inside the input
                  },
                }}
              /> */}
            {/* </Box> */}

            <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                 {t("Coupon Code")}
              </Typography>
              <TextField
                fullWidth
                name="coupon_code"
                value={specialFormdata.coupon_code}
                onChange={handleInputChange}
                error={!!formErrors.coupon_code}
                helperText={formErrors.coupon_code}
                placeholder="Enter Code"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  my: "10px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px", // Adjust top-bottom and left-right padding
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  minLength: 4,
                  maxLength: 12,
                  style: {
                    padding: "5px 7px", // Decrease padding inside the input
                  },
                }}
              />
            </Box>
            {/* Expiration Date & Status */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                pt: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                  }}
                >
                 {t("Expiration Date")}
                </Typography>
                <Box sx={{ flex: 1, position: "relative" }}>
                  <TextField
                    fullWidth
                    type="date"
                    name="expiration_date"
                    value={specialFormdata.expiration_date}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const today = new Date();
                      today.setHours(0, 0, 0, 0); // Normalize today's date for comparison

                      if (selectedDate < today) {
                        setFormErrors((prev) => ({
                          ...prev,
                          expiration_date:
                            "Expiration date cannot be in the past",
                        }));
                      } else {
                        setSpecialFormData((prev) => ({
                          ...prev,
                          expiration_date: e.target.value,
                        }));

                        if (formErrors.expiration_date) {
                          setFormErrors((prev) => ({
                            ...prev,
                            expiration_date: "",
                          }));
                        }
                      }
                    }}
                    error={!!formErrors.expiration_date}
                    helperText={formErrors.expiration_date}
                    sx={{
                      borderRadius: "6px",
                      borderColor: "#C5C5C5",
                      my: "10px",
                    }}
                    InputProps={{
                      sx: {
                        padding: "3px 11px",
                        borderRadius: "12px",
                      },
                    }}
                    inputProps={{
                      min: new Date().toISOString().split("T")[0],
                      style: {
                        padding: "5px 6px",
                      },
                    }}
                  />
                  {/* <CalendarMonthIcon
                      sx={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    /> */}
                </Box>
              </Box>
              <Box sx={{ width: "50%" }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                  }}
                >
                 {t("Status")}
                </Typography>
                <Select
                  name="status"
                  value={specialFormdata.status}
                  onChange={handleInputChange}
                  fullWidth
                  displayEmpty
                  sx={{
                    borderRadius: "12px",
                    // border: "1px solid #C5C5C5",
                    my: "10px",
                    padding: "3px 11px", // Adjust padding to match TextField
                    "& .MuiSelect-select": {
                      padding: "5px 7px", // Inner padding like TextField
                      borderRadius: "12px",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: "12px", // Dropdown border radius
                      },
                    },
                  }}
                >
                  <MenuItem
                    value="1"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Roboto",
                      lineHeight: "100%",
                      fontWeight: "400",
                    }}
                  >
                    Active
                  </MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </Box>
            </Box>

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                marginTop: "14px",
                gap: "6px",
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseAddOffer}
                disabled={isSubmitting}
                sx={{
                  borderRadius: "27px",
                  borderColor: "#0343AA",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "14px",
                  textTransform: "capitalize",
                  width: "28%",
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={!isFormValid}
                // disabled={isSubmitting}
                sx={{
                  backgroundColor: "#0041A8",
                  borderRadius: "27px",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textTransform: "capitalize",
                  width: "28%",
                }}
              >
                {isSubmitting ? <CircularProgress size={24} /> : t("Save")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* delete offer */}
      <Modal
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        aria-labelledby="delete-dialog-title"
      >
        <Box
          sx={{
            width: "400px",
            backgroundColor: "var(--pg-card)",
            color: "var(--pg-text)",
            borderRadius: "8px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            id="delete-dialog-title"
            sx={{
              fontSize: "18px",
              fontFamily: "Roboto",
              fontWeight: "600",
              lineHeight: "100%",
              mb: 2,
            }}
          >
           {t("Delete Offer")}
          </Typography>
          <Typography sx={{ mb: 3 }}>
          {t("Are you sure you want to delete this offer?")}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              onClick={() => setDeleteDialogOpen(false)}
              sx={{
                borderRadius: "27px",
                borderColor: "#0343AA",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "14px",
                textTransform: "capitalize",
              }}
            >
               {t("Cancel")}
            </Button>
            <Button
              onClick={() => handleDeleteSpecial(specialToDelete)}
              variant="contained"
              sx={{
                backgroundColor: "#0041A8",
                borderRadius: "27px",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "21px",
                textTransform: "capitalize",
              }}
            >
             {t("Delete")}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Edit Offer Modal */}
      <Modal
        open={editOffer}
        onClose={handleCloseEditOffer}
        sx={{ overflowY: { xs: "auto" }, bottom: { xs: "10px", sm: "0px" } }}
      >
        <Box
          sx={{
            width: { xs: "85%", sm: "25%" },
            backgroundColor: "var(--pg-card)",
            borderRadius: "8px",
            position: "absolute",
            top: { xs: "60%", sm: "50%" },
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: "#0041A8",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "18px",
                fontFamily: "Roboto",
                fontWeight: "600",
                lineHeight: "100%",
                pl: "12px",
              }}
            >
              {t("Edit Offer")}
            </Typography>
            <IconButton onClick={handleCloseEditOffer} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: "16px 25px 28px 25px" }}>
            {/* Image Upload */}
            <Box
              sx={{
                border: "2px dashed #D3D3D3",
                borderRadius: "8px",
                padding: "16px",
                textAlign: "center",
                margin: "16px 0",
                height: "96px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                position: "relative",
              }}
            >
              <input
                accept="image/*"
                id="image-upload"
                type="file"
                onChange={async (event) => {
                  const file = event.target.files[0];
                  if (!file) return;

                  setIsImageUploading(true);
                  try {
                    // Compress image
                    const options = {
                      maxSizeMB: 1,
                      maxWidthOrHeight: 800,
                      useWebWorker: true,
                    };
                    const compressedFile = await imageCompression(
                      file,
                      options
                    );

                    // Upload to S3
                    const params = {
                      Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
                      Key: `${Date.now()}-${file.name}`,
                      Body: compressedFile,
                      ContentType: file.type,
                      ACL: "public-read",
                    };

                    const uploadResult = await s3.upload(params).promise();
                    setSpecialToEdit({
                      ...specialToEdit,
                      menu_image: uploadResult.Location,
                    });
                  } catch (error) {
                    console.error("Error uploading image:", error);
                  } finally {
                    setIsImageUploading(false);
                  }
                }}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              {isImageUploading ? (
                <CircularProgress size={24} />
              ) : !specialToEdit?.menu_image ? (
                <Button
                  variant="outlined"
                  component="span"
                  sx={{
                    textAlign: "center",
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    fontWeight: "500",
                    lineHeight: "21px",
                    color: "#0041A8",
                    textTransform: "capitalize",
                    border: "1px solid #0041A8",
                    borderRadius: "25px",
                    textAlign: "center",
                    pointerEvents: "none",
                  }}
                >
                  +{t("Upload Image")}
                </Button>
              ) : (
                <Box
                  sx={{ position: "relative", width: "100%", height: "100%" }}
                >
                  <img
                    src={specialToEdit.menu_image || "imageoffer"}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "4px",
                    }}
                  />
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setSpecialToEdit({ ...specialToEdit, menu_image: null });
                    }}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      backgroundColor: "#acacac",
                      "&:hover": {
                        backgroundColor: "#acacac",
                      },
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      width: "24px",
                      height: "24px",
                      padding: "4px",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: "16px", color: "red" }} />
                  </IconButton>
                </Box>
              )}
              {formErrors.menu_image && (
                <Typography color="error" sx={{ mt: 1 }}>
                  {formErrors.menu_image}
                </Typography>
              )}
            </Box>

            {/* Form Fields */}
            <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
             {t("Offer Title")}
              </Typography>
              <TextField
                fullWidth
                name="menu_name"
                value={specialToEdit?.menu_name || ""}
                onChange={(e) => {
                  setSpecialToEdit({
                    ...specialToEdit,
                    menu_name: e.target.value,
                  });
                  // Clear the error message when typing
                  if (formErrors.menu_name) {
                    setFormErrors((prev) => ({ ...prev, menu_name: "" }));
                  }
                }}
                error={!!formErrors.menu_name}
                helperText={formErrors.menu_name}
                placeholder="Enter title"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  my: "10px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px",
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  maxLength: 100,
                  style: {
                    padding: "5px 7px",
                  },
                }}
              />
            </Box>

            <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
               {t("Description")}
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                name="menu_description"
                value={specialToEdit?.menu_description || ""}
                onChange={(e) => {
                  setSpecialToEdit({
                    ...specialToEdit,
                    menu_description: e.target.value,
                  });
                  // Clear the error message when typing
                  if (formErrors.menu_description) {
                    setFormErrors((prev) => ({
                      ...prev,
                      menu_description: "",
                    }));
                  }
                }}
                error={!!formErrors.menu_description}
                helperText={formErrors.menu_description}
                placeholder="Enter description"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  my: "10px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px",
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  maxLength: 500,
                  style: {
                    padding: "5px 7px",
                  },
                }}
              />
            </Box>

            {/* <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                Price
              </Typography>
              <TextField
                fullWidth
                name="price"
                type="number"
                value={specialToEdit?.price || ""}
                onChange={(e) => {
                  setSpecialToEdit({ ...specialToEdit, price: e.target.value });
                  // Clear the error message when typing
                  if (formErrors.price) {
                    setFormErrors((prev) => ({ ...prev, price: "" }));
                  }
                }}
                error={!!formErrors.price}
                helperText={formErrors.price}
                placeholder="Enter price"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  my: "10px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px",
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  style: {
                    padding: "5px 7px",
                  },
                }}
              />
            </Box> */}

            <Box sx={{ pt: "9px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                 {t("Coupon Code")}
              </Typography>
              <TextField
                fullWidth
                name="coupon_code"
                value={specialToEdit?.coupon_code || ""}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setSpecialToEdit({
                    ...specialToEdit,
                    coupon_code: newValue,
                  });
                  // Clear the error message when typing
                  if (formErrors.coupon_code) {
                    setFormErrors((prev) => ({ ...prev, coupon_code: "" }));
                  }
                }}
                error={!!formErrors.coupon_code}
                helperText={formErrors.coupon_code}
                placeholder="Enter Code"
                sx={{
                  borderRadius: "6px",
                  borderColor: "#C5C5C5",
                  my: "10px",
                }}
                InputProps={{
                  sx: {
                    padding: "3px 11px",
                    borderRadius: "12px",
                  },
                }}
                inputProps={{
                  minLength: 4,
                  maxLength: 12,
                  style: {
                    padding: "5px 7px",
                  },
                }}
              />
            </Box>

            {/* Expiration Date & Status */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                pt: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                  }}
                >
                  {t("Expiration Date")}
                </Typography>
                <Box sx={{ flex: 1, position: "relative" }}>
                <TextField
                    fullWidth
                    type="date"
                    name="expiration_date"
                    value={specialToEdit?.expiration_date || ""}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);

                      if (selectedDate < today) {
                        setFormErrors((prev) => ({
                          ...prev,
                          expiration_date:
                            "Expiration date cannot be in the past",
                        }));
                      } else {
                        setSpecialToEdit({
                          ...specialToEdit,
                          expiration_date: e.target.value,
                        });
                        // Clear the error message when valid date is selected
                        if (formErrors.expiration_date) {
                          setFormErrors((prev) => ({
                            ...prev,
                            expiration_date: "",
                          }));
                        }
                      }
                    }}
                    error={!!formErrors.expiration_date}
                    helperText={formErrors.expiration_date}
                    sx={{
                      borderRadius: "6px",
                      borderColor: "#C5C5C5",
                      my: "10px",
                    }}
                    InputProps={{
                      sx: {
                        padding: "3px 11px",
                        borderRadius: "12px",
                      },
                    }}
                    inputProps={{
                      min: new Date().toISOString().split("T")[0],
                      style: {
                        padding: "5px 6px",
                      },
                    }}
                  />
              </Box>
              </Box>
              <Box sx={{ width: "50%" }}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                  }}
                >
                  {t("Status")}
                </Typography>
                <Select
                  name="status"
                  // value={specialToEdit?.status === "1" ? "Active" : "Inactive"}
                  value={specialToEdit?.status}
                  onChange={(e) =>
                    setSpecialToEdit({
                      ...specialToEdit,
                      // status: e.target.value === "Active" ? "1" : "0"
                      status: e.target.value,
                    })
                  }
                  fullWidth
                  displayEmpty
                  sx={{
                    borderRadius: "12px",
                    my: "10px",
                    padding: "4px 12px",
                    "& .MuiSelect-select": {
                      padding: "5px 7px",
                      borderRadius: "12px",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: "12px",
                      },
                    },
                  }}
                >
                  <MenuItem
                    value="Active"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Roboto",
                      lineHeight: "100%",
                      fontWeight: "400",
                    }}
                  >
                    Active
                  </MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </Box>
            </Box>

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                marginTop: "16px",
                gap: "6px",
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseEditOffer}
                disabled={isSubmitting}
                sx={{
                  borderRadius: "27px",
                  borderColor: "#0343AA",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "14px",
                  textTransform: "capitalize",
                  width: "28%",
                }}
              >
                 {t("Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleEditSubmit}
                disabled={isSubmitting}
                sx={{
                  backgroundColor: "#0041A8",
                  borderRadius: "27px",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "21px",
                  textTransform: "capitalize",
                  width: "28%",
                }}
              >
                {isSubmitting ? <CircularProgress size={24} /> : t("Update")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default Offers;
